import React from 'react';
import './AttributeHover.css';
import { getDangerousHtml } from '../../helpers/components';

// const getHoverImageUrl = (imgUrl) => imgUrl.replace(".jpg", "_1x.jpg");

const AttributeHover = ({ image, label, description, price, offsetTop}) => (
  <div className="pdp-tooltip" style={{ top: `${offsetTop}px` }}>
    <img width={200} height={200} src={image} alt="" />
    <p className="pdp-tooltip__label">{label}</p>
    {
      description
        ? <p className="pdp-tooltip__description" dangerouslySetInnerHTML={getDangerousHtml(description)}></p>
        : null
    }
    {
      price
        ? <p className="pdp-tooltip__price">{price}</p>
        : null
    }
  </div>
);

export default AttributeHover;


// WEBPACK FOOTER //
// ./src/components/AttributeHover/index.js